import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@material-ui/core";
import { getDatabase, ref, update } from "firebase/database";
import React from "react";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
const CashoutItem = ({ cashout, change, setChange }) => {
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  function updateCashout(state) {
    const db = getDatabase();
    setLoading(true);
    update(ref(db, `CashoutRequest/${cashout.id}`), {
      state,
    })
      .then((res) => {
        setChange(!change);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const goToSingleUserPage = () => {
    history.push("/user/" + cashout?.userId);
  };

  return (
    <div>
      <Card elevation={1}>
        <CardHeader
          //   avatar={<Person aria-label="recipe">R</Person>}
          title={`Cashout Method: ${cashout?.cashoutMethod}`}
          subheader={`Date: ${cashout.time}`}
        />
        <CardContent>
          <Typography variant="h5" color="textPrimary">
            Total Amount: {cashout.amount}
          </Typography>
          <Typography variant="h6" color="textPrimary">
            Status : {cashout?.state}
          </Typography>
          <Typography variant="h6" color="textPrimary">
            Account No : {cashout?.accountNo}
          </Typography>

          <h2
            style={{ cursor: "pointer", color: "green" }}
            onClick={() => goToSingleUserPage()}
          >
            Go To User Profile
          </h2>
          {cashout?.state === "pending" ? (
            loading ? (
              <BeatLoader loading={loading} />
            ) : (
              <Button
                variant="outlined"
                onClick={() => updateCashout("accepted")}
              >
                Accept
              </Button>
            )
          ) : cashout?.state === "accepted" ? (
            loading ? (
              <BeatLoader loading={loading} />
            ) : (
              <Button
                onClick={() => updateCashout("success")}
                variant="outlined"
              >
                Success
              </Button>
            )
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
};

export default CashoutItem;
